import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'

@customElement('cairn-loader')
export class CairnLoader extends LitElement {
  static override styles = css`
    :host {
      display: inline-block;
    }

    .loader {
      display: flex;
      align-items: center;
      gap: var(--cairn-spacing-sm, 8px);
    }

    .spinner {
      width: var(--spinner-size, 24px);
      height: var(--spinner-size, 24px);
      border: 2px solid var(--cairn-border-color, #e2e8f0);
      border-top: 2px solid var(--cairn-primary-color, #3b82f6);
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }

    .text {
      color: var(--cairn-text-secondary-color, #64748b);
      font-size: var(--cairn-text-size-sm, 14px);
    }

    /* Size variants */
    .small .spinner {
      --spinner-size: 16px;
      border-width: 1px;
    }

    .small .text {
      font-size: var(--cairn-text-size-xs, 12px);
    }

    .large .spinner {
      --spinner-size: 32px;
      border-width: 3px;
    }

    .large .text {
      font-size: var(--cairn-text-size-md, 16px);
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }
  `

  @property({ type: String })
  size: 'small' | 'medium' | 'large' = 'medium'

  @property({ type: String })
  text = ''

  override render(): unknown {
    return html`
      <div class="loader ${this.size}">
        <div class="spinner"></div>
        ${this.text ? html`<span class="text">${this.text}</span>` : ''}
      </div>
    `
  }
}
